export const selectToken = (state) => state.user.token;

export const selectUser = (state) => state.user;

export const selectAdmin = (state) => state.user.isAdmin;
